import { useMemo, useState } from 'react';
import wallet from '~/assets/icons/wallet.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useInputAction, useObservable } from '~/rage';
import { Currency, InputAction } from '~/shared';
import { MoneyInput } from '../../components/MoneyInput';
import { useLocalVehicle } from '../../hooks';
import {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledClockIcon,
	StyledContainer,
	StyledDivider,
	StyledInfoBottomContainer,
	StyledInfoContainer,
	StyledPriceContainer,
	StyledTimeContainer,
} from './CarMarketCreate.styled';

const CarMarketCreate = () => {
	const vehicleAdvertPrice = useObservable(
		rage.vehicleMarket.getVehicleAdvertPrice(),
	);
	const maxSellTimeMs = useObservable(rage.vehicleMarket.getMaxSellTimeMs());
	const { modelId } = useLocalVehicle();
	const [value, setValue] = useState(0);
	const [loading, setLoading] = useState(false);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const maxSellTime = useMemo(() => {
		const totalMinutes = Math.floor(
			((maxSellTimeMs as number) || 0) / 1000 / 60,
		);
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;
		return { hours, minutes, totalMinutes };
	}, [maxSellTimeMs]);

	const vehicleName = useMemo(() => {
		if (!modelId) return '';
		return rage.vehicles.getVehicleNameByModel(modelId);
	}, [modelId]);

	const handleCreateAdvert = async () => {
		if (!value) {
			return;
		}

		setLoading(true);
		await rage.vehicleMarket
			.createAdvert(value)
			.catch((err) => rage.notifications.showException(err));
		await rage.vehicleMarket
			.exitMenu()
			.catch((err) => rage.notifications.showException(err));
		setLoading(false);
	};

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.vehicleMarket
			.exitMenu()
			.catch((err) => rage.notifications.showException(err));
	});

	return (
		<StyledContainer>
			<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.75 }}>
				Вы действительно хотите выставить {vehicleName} на авторынок?
			</Text>
			<MoneyInput
				value={value}
				onChange={setValue}
				placeholder={'Введите стоимость'}
			/>
			<StyledInfoContainer>
				<StyledDivider />
				<StyledInfoBottomContainer>
					<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
						Время размещения
					</Text>
					<StyledTimeContainer>
						<Text>
							{maxSellTime.hours > 0 ? (
								<>
									{maxSellTime.hours} <span>ч.</span>
									{maxSellTime.minutes > 0 ? (
										<>
											{' '}
											{maxSellTime.minutes} <span>мин.</span>
										</>
									) : null}
								</>
							) : (
								<>
									{maxSellTime.minutes} <span>мин.</span>
								</>
							)}
						</Text>
						<StyledClockIcon />
					</StyledTimeContainer>
				</StyledInfoBottomContainer>
				<StyledInfoBottomContainer>
					<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
						Стоимость аренды
					</Text>
					<StyledPriceContainer>
						<Text>{vehicleAdvertPrice.toLocaleString('ru-RU')}</Text>
						<CurrencyIcon icon={rubleIcon} size="md" style={{ opacity: 0.5 }} />
					</StyledPriceContainer>
				</StyledInfoBottomContainer>
			</StyledInfoContainer>
			<StyledButtonsContainer>
				<Button
					color={ButtonColors.Default}
					onClick={() => rage.vehicleMarket.exitMenu()}
					height={ButtonHeight.Height50}
				>
					<Text>Отменить</Text>
				</Button>
				<Button
					color={ButtonColors.Buy}
					onClick={handleCreateAdvert}
					height={ButtonHeight.Height50}
					disabled={!value || loading}
					style={{ padding: '0 10px' }}
				>
					<StyledButtonContent>
						{value ? <img src={wallet} /> : null}
						<Text>{value ? 'Оплатить' : 'Введите стоимость'}</Text>
					</StyledButtonContent>
				</Button>
			</StyledButtonsContainer>
		</StyledContainer>
	);
};

export { CarMarketCreate };
